package ai.jessie.web.pages.organisations

import ai.jessie.web.customers.unavailableCustomerProblem
import ai.jessie.web.customers.validCustomerId
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

// UC-012 A1, A2, A4 and A8. An invalid customer ID sends no request and shows the same neutral
// absence as a customer outside the organisation (A11).
@Page("{organisationId}/customers/{customerId}")
@Composable
fun organisationCustomerPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val customerId = ctx.route.dynamicParams["customerId"].orEmpty()
    when {
        !validOrganisationId(organisationId) ->
            customerProblemFrame(organisationId, organisationRequiredProblem())
        !validCustomerId(customerId) ->
            customerProblemFrame(organisationId, unavailableCustomerProblem())
        else -> key(organisationId, customerId) { customersContent(organisationId, customerId) }
    }
}
